import React from 'react';
import { Link as RouterLink, Route } from 'react-router-dom';
import { FontIcon, ListItem } from 'react-md';

//Import CSS
import '../css/NavLink.css';

const NavLink = (props) => {
const {to,exact,icon,label,...rest} = props;

  return <Route path={to} exact={exact}>
    {({ match }) => {
      let leftIcon;
      if (icon) {
        leftIcon = <FontIcon>{icon}</FontIcon>;
      }

      return (
        <ListItem
          component={RouterLink}
          active={!!match}
          to={to}
          primaryText={label}
          leftIcon={leftIcon}
          className={!match ? "navLinkStyle":"navLinkStyle-active"}
          {...rest}
        />
      );
    }}
  </Route>
};

export default NavLink;